module.exports = __webpack_public_path__ + "static/media/arrow-left.baaa63ce.svg";